import {Component, Input} from '@angular/core';
import {AttributeType, DetailAttribute, ND} from '@pt/pt-models';
import {Router} from '@angular/router';

@Component({
  selector: 'pt-details-attribute',
  template: `
    <div class='pt-details-attribute' *ngIf='attribute'>
      <!--KEY-->
      <div class='key'>
        <pt-icon *ngIf='attribute.keyIcon'
                 [key]='attribute.keyIcon.key'
                 [iconType]='attribute.keyIcon.type'
                 [size]='iconSize'></pt-icon>
        <div>{{ attribute.key | async }}</div>
      </div>

      <div class="value">
        <ng-container
          *ngIf='attribute.link && (attribute.value || attribute.valueChildren); then LINK; else NO_LINK'></ng-container>
        <ng-template #LINK>
          <ng-container *ngIf='attribute.valueChildren; then LINK_CHILDREN; else LINK_NO_CHILDREN'></ng-container>
          <ng-template #LINK_CHILDREN>
            <div class="d-flex flex-column">
              <a class='btn btn-link btn-attribute text-link' [class.mt-1]="idx > 0"
                 *ngFor="let children of attribute.valueChildren; index as idx"
                 (click)='navigateToBlankPage(children)'
                 [ngClass]='[(children?.cssClass ? children?.cssClass : "text-muted")]'>
                <pt-details-attribute-viewer
                  class='display-contents'
                  [attribute]='children'>
                </pt-details-attribute-viewer>
                <ng-content select='[additionalValue]'></ng-content>
              </a>
            </div>

          </ng-template>
          <ng-template #LINK_NO_CHILDREN>
            <a class='btn btn-link btn-attribute text-link'
               (click)='navigateToBlankPage(attribute)'
               [ngClass]='[(attribute?.cssClass ? attribute?.cssClass : "text-muted")]'>
              <pt-details-attribute-viewer
                class='display-contents'
                [attribute]='attribute'>
              </pt-details-attribute-viewer>
              <ng-content select='[additionalValue]'></ng-content>
            </a>
          </ng-template>

        </ng-template>
        <ng-template #NO_LINK>
          <ng-container
            *ngIf='attribute.valueChildren?.length > 0; then NO_LINK_CHILDREN; else NO_LINK_NO_CHILDREN'></ng-container>
          <ng-template #NO_LINK_CHILDREN>
            <div class="d-flex flex-column">
              <div *ngFor="let children of attribute.valueChildren"
                   [ngClass]='[(children?.cssClass ? children?.cssClass : "text-muted")]'>
                <div class="d-flex">
                  <div class='sub-key' *ngIf="children.key">
                    <pt-icon *ngIf='children.keyIcon'
                             [key]='children.keyIcon.key'
                             [iconType]='children.keyIcon.type'
                             [size]='iconSize'></pt-icon>
                    <div>{{ children.key | async }}</div>
                  </div>
                  <pt-details-attribute-viewer
                    class='display-contents'
                    [attribute]='children'>
                  </pt-details-attribute-viewer>
                </div>
                <ng-content select='[additionalValue]'></ng-content>
              </div>
            </div>
          </ng-template>
          <ng-template #NO_LINK_NO_CHILDREN>
            <div [ngClass]='[(attribute?.cssClass ? attribute?.cssClass : "text-muted")]'>
              <pt-details-attribute-viewer
                class='display-contents'
                [attribute]='attribute'>
              </pt-details-attribute-viewer>
              <ng-content select='[additionalValue]'></ng-content>
            </div>
          </ng-template>
        </ng-template>
      </div>

    </div>
    <div>
      <ng-content select='[customAttributes]'></ng-content>
    </div>
  `,
  styles: [`
    .pt-details-attribute {
      margin: 0;
      display: flex;
      font-size: 13px;
      padding: 5px 10px;
      flex-direction: row;
      align-items: baseline;
      justify-content: space-between;
      border-bottom: 1px solid #f5f5f5;
    }

    .pt-details-attribute .key {
      width: 200px;
      display: flex;
      min-height: 13px;
      line-height: 13px;
      font-weight: normal;
      align-items: flex-end;
    }

    .pt-details-attribute .sub-key {
      display: flex;
      min-height: 13px;
      line-height: 13px;
      align-items: flex-end;
    }

    .pt-details-attribute .value {
      display: flex;
      overflow: auto;
      min-height: 18px;
      max-height: 100px;
      line-height: 18px;
      align-items: baseline;
      width: calc(100% - 202px);
    }

    .pt-details-attribute .value::-webkit-scrollbar {
      width: 5px;
      height: 5px;
    }

    .pt-details-attribute .value::-webkit-scrollbar-track {
      background: #f1f1f1;
    }

    .pt-details-attribute .value::-webkit-scrollbar-thumb {
      background: #888;
    }

    .pt-details-attribute .value::-webkit-scrollbar-thumb:hover {
      background: #555;
    }

    .pt-details-attribute .btn-attribute {
      line-height: 13px;
      font-size: 13px;
      padding: 0;
      margin: 0;
    }
  `]
})
export class DetailsAttributeComponent {

  @Input() attribute: DetailAttribute;
  AttributeType = AttributeType;
  iconSize = 13;
  ND = ND;

  constructor(private router: Router) {
  }

  navigateToBlankPage(attribute: DetailAttribute) {
    const url = this.router.createUrlTree(attribute.link, {queryParams: attribute?.queryParamsLink});
    window.open(url.toString(), '_blank');
  }

}
